import { ResponseList } from './ResponseList';

export function ResponseListWrapper() {
	return (
		<div className="mb-16">
			<ResponseList />
		</div>
	);
}
